var PolyPointMode = {
    STRAIGHT: 0,
    CORNER_90: 1,
    ARC_90: 2,
    ARC_180: 3,
    ARC_GENERAL: 4,
    NUM_MODES: 5,
    ARC_45: 99 //disabled
};

PolyPointMode.name_map = {};
PolyPointMode.name_map[PolyPointMode.STRAIGHT] = "STRAIGHT";
PolyPointMode.name_map[PolyPointMode.CORNER_90] = "CORNER_90";
// PolyPointMode.name_map[PolyPointMode.ARC_45] = "ARC_45";
PolyPointMode.name_map[PolyPointMode.ARC_90] = "ARC_90";
PolyPointMode.name_map[PolyPointMode.ARC_180] = "ARC_180";
PolyPointMode.name_map[PolyPointMode.ARC_GENERAL] = "ARC_GENERAL";

PolyPointMode.isArcMode = function(mode) {
    return mode >= PolyPointMode.ARC_90 && mode <= PolyPointMode.ARC_GENERAL;
};

module.exports = PolyPointMode;

